import {
  ChangeDetectorRef,
  DestroyRef,
  Directive,
  inject,
  Input,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { AuthService } from '@shared/store/auth/auth.service';
import type { AllowedRolesPermissions } from '@shared/types/auth.type';

@Directive({
  selector: '[auxAuthorize]',
  standalone: true,
})
export class AuthorizeDirective {
  private readonly authService = inject(AuthService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly ref = inject(ChangeDetectorRef);
  private readonly templateRef = inject(TemplateRef<unknown>);
  private readonly viewContainer = inject(ViewContainerRef);

  private hasView = false;

  private adjustView(visible: boolean) {
    if (visible) {
      if (!this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      }
    } else if (this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }

    this.ref.detectChanges();
  }

  @Input() set auxAuthorize(allowedRolesPermissions: AllowedRolesPermissions) {
    this.authService
      .isAuthorized$(allowedRolesPermissions)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((authorized) => this.adjustView(authorized));
  }
}
